import React from 'react';
import { Check, Brain, Heart, Eye, Shield, Smartphone, Headphones, Clock } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 bg-[#FDF8F4] px-4" data-id="element-238">
      <div className="max-w-5xl mx-auto" data-id="element-239">
        <div className="text-center mb-16" data-id="element-240">
          <span className="text-[#C06B6B] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-241">
            La Solución
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6" data-id="element-242">
            🔓 La solución no es calmar la mente
          </h2>
          <p className="text-xl text-[#C4973B] font-bold max-w-2xl mx-auto uppercase tracking-wide" data-id="element-243">
            Es reentrenar el cuerpo
          </p>
          <div className="mt-8 max-w-3xl mx-auto bg-white p-6 rounded-2xl shadow-sm border border-[#C06B6B]/10" data-id="element-244">
            <p className="text-lg text-gray-600 mb-4" data-id="element-245">
              El Protocolo Calma-5™ no es: Meditación larga / Distracción /
              Pensar positivo / "Forzarte a ser fuerte".
            </p>
            <p className="text-xl font-medium text-gray-800" data-id="element-246">
              Es regulación corporal guiada.
            </p>
            <p className="mt-4 text-gray-600 italic" data-id="element-247">
              👉 No intentas callar la mente. Le enseñas al cuerpo que el
              peligro ya pasó.
              <br data-id="element-248" />
              <span className="font-bold text-[#C06B6B]" data-id="element-249">
                Cuando el cuerpo se siente a salvo, la mente deja de gritar.
              </span>
            </p>
          </div>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden mb-16" data-id="element-250">
          <div className="grid md:grid-cols-2" data-id="element-251">
            <div className="p-8 md:p-12 bg-[#C06B6B] text-white flex flex-col justify-center" data-id="element-252">
              <h3 className="text-2xl font-serif font-bold mb-6" data-id="element-253">
                🎧 ¿Qué es exactamente Calma-5™?
              </h3>
              <ul className="space-y-4 mb-8" data-id="element-254">
                {['1 audio guiado de 5 minutos', 'Voz suave que te guía paso a paso', 'Respiración vagal sin esfuerzo', 'Enfoque corporal calmante', 'Ritmo fisiológico seguro', 'Ideal para usar cuando la ansiedad aparece'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-255">
                    <div className="bg-white/20 p-1 rounded-full flex-shrink-0" data-id="element-256">
                      <Check className="h-4 w-4 text-white" data-id="element-257" />
                    </div>
                    <span className="text-lg" data-id="element-258">{item}</span>
                  </li>)}
              </ul>

              <div className="grid grid-cols-3 gap-4 pt-6 border-t border-white/20" data-id="element-259">
                <div className="text-center" data-id="element-260">
                  <Smartphone className="h-6 w-6 mx-auto mb-2 text-white/80" data-id="element-261" />
                  <span className="text-xs text-white/80 block leading-tight" data-id="element-262">
                    Desde tu celular
                  </span>
                </div>
                <div className="text-center" data-id="element-263">
                  <Headphones className="h-6 w-6 mx-auto mb-2 text-white/80" data-id="element-264" />
                  <span className="text-xs text-white/80 block leading-tight" data-id="element-265">
                    Con audífonos
                  </span>
                </div>
                <div className="text-center" data-id="element-266">
                  <Clock className="h-6 w-6 mx-auto mb-2 text-white/80" data-id="element-267" />
                  <span className="text-xs text-white/80 block leading-tight" data-id="element-268">
                    Solo 5 minutos
                  </span>
                </div>
              </div>

              <div className="mt-8 p-4 bg-white/10 rounded-xl backdrop-blur-sm border border-white/20" data-id="element-269">
                <p className="font-medium text-center text-lg" data-id="element-270">
                  "👉 No se entiende. Se siente."
                </p>
              </div>
            </div>

            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-271">
              <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-272">
                💫 En solo 5 minutos al día puedes experimentar:
              </h3>

              <div className="grid grid-cols-1 gap-4" data-id="element-273">
                {[{
                icon: Heart,
                text: 'Respiración más profunda y natural'
              }, {
                icon: Shield,
                text: 'Mandíbula y pecho más sueltos'
              }, {
                icon: Eye,
                text: 'Silencio mental espontáneo'
              }, {
                icon: Brain,
                text: 'Sensación de seguridad interna'
              }, {
                icon: Clock,
                text: 'Descanso real, no solo cansancio'
              }].map((feature, i) => <div key={i} className="flex items-center gap-3 p-3 bg-[#FAF5EF] rounded-lg" data-id="element-274">
                    <feature.icon className="h-5 w-5 text-[#C06B6B]" data-id="element-275" />
                    <span className="text-gray-800 font-medium" data-id="element-276">
                      {feature.text}
                    </span>
                  </div>)}
              </div>

              <p className="mt-8 text-lg text-gray-600 italic border-t pt-6 text-center" data-id="element-277">
                No como alguien que "se calma"… sino como alguien que vuelve a
                habitar su cuerpo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}